import { HandshakeIcon } from "@phosphor-icons/react"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useHelpContext } from "@dehub/theme"
import { PageLayout } from "../../components/layout"
import { CustodyTransfers } from "../../components/custody-transfers"
import { usePermission } from "../../components/permission"

export function CustodyTransfersPage() {
  const { t } = useTranslation(["delivery", "common"])
  const breadcrumbs = useBreadcrumb(t)
  const ORD_LIST = usePermission("ORD_DN_DRAFT_LIST")
  // @dehub/help: same content as the hub's Хүлээлцэл tab (screen-map → supplier-delivery-list).
  const { set: setHelpContext } = useHelpContext()
  useEffect(() => {
    setHelpContext({ when: "HANDOVER" })
  }, [setHelpContext])

  return (
    <PageLayout
      icon={<HandshakeIcon size={22} />}
      title={t("custody.breadcrumb")}
      subTitle={t("custody.pageSubtitle")}
      breadcrumb={breadcrumbs}
    >
      {ORD_LIST.hasAccess ? <CustodyTransfers /> : ORD_LIST.accessDenied()}
    </PageLayout>
  )
}

const useBreadcrumb = (t: (key: string) => string) => [
  { to: "/", label: t("common:breadcrumb.home") },
  { label: t("delivery:custody.breadcrumb") },
]
